module.exports = __webpack_public_path__ + "static/media/sweden-icon.79da0f18.svg";